import React from 'react'
import AccountBudgets from 'src/app/AccountBudgets/AccountBudgets'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { accountBudgetsRouteProps } from 'src/navigation/routeProps'

const AccountBudgetsAppRoute: AppRoute = {
  id: AppLocation.AccountBudgets,
  routeProps: accountBudgetsRouteProps,
  component: <AccountBudgets />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default AccountBudgetsAppRoute
